<h3 class="mat-headline-6 mt2 flex justify-start content-center items-center flex-row">
  <mat-icon class="icon-small mr1">assignment_ind</mat-icon>
  <span translate="">Settings</span>
</h3>

<div class="mb1">
  <mat-checkbox color="primary" [formControl]="existingControl()"><p translate="">Existing client</p></mat-checkbox>
</div>

@if (businessunitControl()) {
  <unite-businessunit-input [control]="businessunitControl()">
  </unite-businessunit-input>
}

<unite-user-autocomplete [label]="'Client adviser' | translate" required="" [control]="userControl()">
</unite-user-autocomplete>
